import { cn } from 'Utils/cn';
import PropTypes from 'prop-types';
import OutlineCloseSmall from 'Components/Atoms/OutlineIcons/OutlineCloseSmall';

export default function ButtonClear(props) {
    const { onClear, className } = props;

    return (
        <div
            className={cn(
                'shrink-0 text-dark-blue rounded-full border border-gray-200 flex items-center justify-center cursor-pointer hover:border-gray-300 transition-colors size-6 shadow-sm',
                className,
            )}
            role="button"
            tabIndex={0}
            onClick={(e) => {
                e.stopPropagation();
                onClear?.();
            }}
        >
            <OutlineCloseSmall size={20} />
        </div>
    );
}

ButtonClear.propTypes = {
    onClear: PropTypes.func,
    className: PropTypes.string,
};
